
import { apiFetch } from './client';
import type { WidgetDataRequest, WidgetDataResponse } from '../types/contracts';

export const widgetsApi = {
  getData: (req: WidgetDataRequest) =>
    apiFetch<WidgetDataResponse>('/api/widgets/data', { method: 'POST', body: JSON.stringify(req) }),
};
